import Immutable from 'immutable';

import Predicate from 'sharedreact/data/Predicate';
import ClassFactory from 'sharedreact/utils/ClassFactory';

const Content: {
  id: string,
  name: string,
  key: string,
  predicate?: Predicate
} = {
  id: '',
  name: '',
  key: '',
  predicate: undefined
};

class SmartView extends Immutable.Record(Content) {
  static fromJS (json: object): SmartView {
    return ClassFactory.createFromJson(json, SmartView);
  }
}

export default SmartView;
